import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Container, Alert, Row, Col } from 'react-bootstrap';
import { fetchOrdersByMonth } from '../redux/slice/orderSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import LoadingComponent from '../components/LoadingComponent';
import { getMonthName } from '../utils/getMonthName';
import { formatDate } from '../utils/formatDate';

const OrdersPage = () => {
  const dispatch = useDispatch();
  const { orders, status, error } = useSelector(state => state.orders);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchOrdersByMonth({ month: currentMonth, year: currentYear }));
      } catch (error) {
        //console.error('Error fetching data:', error);

      }
    };

    fetchData();
  }, [dispatch, currentYear, currentMonth]);

  const goToNextMonth = () => {
    if (currentMonth === 12) {
      setCurrentMonth(1);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const goToPreviousMonth = () => {
    if (currentMonth === 1) {
      setCurrentMonth(12);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  };

  const monthNames = [
    "Ιανουαρίου", "Φεβρουαρίου", "Μαρτίου", "Απριλίου",
    "Μαίου", "Ιουνίου", "Ιουλίου", "Αυγούστου",
    "Σεπτεμβρίου", "Οκτωβρίου", "Νοεμβρίου", "Δεκεμβρίου"
  ];

  const currentMonthName = monthNames[currentMonth - 1];

  return (<>
    {status === 'loading' && <LoadingComponent />}
    {status === 'failed' && <Alert variant="danger">{error}</Alert>}
    {(status === 'succeeded') && (<Container fluid style={{ minHeight: '100vh', backgroundColor: 'white', borderRadius: '10px', paddingTop: '10px' }}>
      <h2 className="text-center my-4" style={{ color: 'black' }}>Παραγγελίες {' '}{currentMonthName}</h2>
      {/* Κουμπιά αλλαγής μήνα */}
      <Row className="text-center mb-2">
        <Col xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
          <div className="month-container" style={{ display: 'flex', alignItems: 'center' }}>
            <button className="month-item" onClick={goToPreviousMonth}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
            <div className="month-toggle">
              {currentMonthName}, {currentYear}
            </div>
            <button className="month-item" onClick={goToNextMonth}>
              <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </div>
        </Col>
      </Row>

      {status === 'loading' && <LoadingComponent />}
      {status === 'failed' && <Alert variant="danger">{error}</Alert>}
      {(status === 'succeeded' && orders.length === 0) && <Alert variant="warning">{'Δεν υπάρχουν παραγγελίες για τον μήνα '}<strong>{getMonthName(currentMonth)}</strong></Alert>}
      {(status === 'succeeded' && orders.length > 0) && (

        <Table xs={12} className='table-menu' bordered striped responsive>
          <thead>
            <tr>
              <th>Ημερομηνία</th>
              <th>Πιάτο</th>
              <th>Σύνολο</th>
              <th>Παραλαβή</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, index) => {
              const meals = [
                { name: order?.meal_one?.name || 'Πιάτο 1', quantity: order?.quantity_one, takeaway: order?.takeaway },
                { name: order?.meal_two?.name || 'Πιάτο 2', quantity: order?.quantity_two, takeaway: order?.takeaway },
                { name: order?.meal_three?.name || 'Πιάτο 3', quantity: order?.quantity_three, takeaway: order?.takeaway },
                { name: 'Άρτος Λευκός', quantity: order?.bread_quantity, takeaway: order?.takeaway },
                { name: 'Άρτος Ολικής', quantity: order?.grained_bread_quantity, takeaway: order?.takeaway }
              ];

              return meals.map((meal, idx) => (
                <tr key={`${order?.id}-${idx}`}>
                  {idx === 0 && (
                    <td rowSpan={5} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      {formatDate(order?.date)}
                    </td>
                  )}
                  <td>{meal?.name}</td>
                  <td>{meal?.quantity}</td>
                  {idx === 0 && (

                    <td rowSpan={5} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      {meal?.takeaway}
                    </td>
                  )}
                </tr>
              ));
            })}
          </tbody>
        </Table>


      )}

    </Container>)}
  </>
  );
};

export default OrdersPage;
